document.addEventListener('DOMContentLoaded', function () {
  const depositProductId = '12345678901234'; // Replace with the ID of your "Bottle Deposit" variant

  function needsDeposit(items) {
    return items.some(item => item.product_title.includes('Bottle Deposit'));
  }

  function hasTriggerProduct(items) {
    return items.some(item => item.product_tags && item.product_tags.includes('requires_deposit'));
  }

  product_map = {
    212: {quantity: 3},
    213: {quantity: 6},
    214: {quantity: 24},
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const items = cart.items;

      const hasDeposit = needsDeposit(items);
      const requiresDeposit = hasTriggerProduct(items);

      console.log('Cart items:', items);
      console.log('Has deposit:', hasDeposit);
      console.log('Requires deposit:', requiresDeposit);

            // Add deposit if needed
            if (requiresDeposit && !hasDeposit) {
              console.log('Adding deposit product to cart');
            }
            if (!requiresDeposit && hasDeposit) {
              console.log('Removing deposit product from cart');
            }


    });
});